document.addEventListener('DOMContentLoaded', function() {
    var productDetailsSection = document.getElementById('product-details-section');
    var navLinks = productDetailsSection.querySelectorAll('.nav-link');

    navLinks.forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            var tabId = this.getAttribute('href').substring(1);

            var tabContainer = document.querySelectorAll('.tab-container > div');
            tabContainer.forEach(function(tab) {
                tab.style.display = 'none';
            });

            // Remove active class from all nav links
            navLinks.forEach(function(link) {
                link.classList.remove('active');
            });

            // Show the selected tab content
            var selectedTab = document.getElementById(tabId);
            selectedTab.style.display = 'flex';

            // Add active class to the clicked nav link
            this.classList.add('active');
        });
    });
});

document.addEventListener('DOMContentLoaded', function() {
    const scrollAmount = 200; // Adjust this value based on desired scroll amount per click

    const reviewListContainer = document.querySelector('#product-vertical-review-scroll .review-list-container');
    const leftArrow = document.querySelector('#product-vertical-review-scroll .left-arrow');
    const rightArrow = document.querySelector('#product-vertical-review-scroll .right-arrow');

    leftArrow.addEventListener('click', function() {
        // Scrolls to the left
        reviewListContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    rightArrow.addEventListener('click', function() {
        // Scrolls to the right
        reviewListContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    // Drag to scroll
    let isDown = false;
    let startX;
    let scrollLeft;

    reviewListContainer.addEventListener('mousedown', (e) => {
        isDown = true;
        startX = e.pageX - reviewListContainer.offsetLeft;
        scrollLeft = reviewListContainer.scrollLeft;
    });

    reviewListContainer.addEventListener('mouseleave', () => {
        isDown = false;
    });

    reviewListContainer.addEventListener('mouseup', () => {
        isDown = false;
    });

    reviewListContainer.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - reviewListContainer.offsetLeft;
        const walk = (x - startX) * 3;
        reviewListContainer.scrollLeft = scrollLeft - walk;
    });

    // Prevent images from being dragged
    document.querySelectorAll('#product-vertical-review-scroll .media *').forEach(element => {
        element.addEventListener('dragstart', (e) => {
            e.preventDefault();
        });
    });
});